import {ComponentStore} from '@ngrx/component-store';
import {Injectable} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Observable, switchMap, withLatestFrom} from 'rxjs';
import {ReportStore} from './report.store';
import {filter, map, tap} from 'rxjs/operators';
import {ReportStoreState} from './report';
import {FormValidators} from '../../validators/form-validators';
import {AdReportParams} from '../../interfaces/ad-reports';
import {AppState} from '../store';
import {Store} from '@ngrx/store';
import {selectBackgroundLoaded} from '../selectors';

@Injectable()
export class ReportParamsStore extends ComponentStore<null> {
  public readonly form: FormGroup<{ [key: string]: FormControl }> = new FormGroup({}, [Validators.required]);

  private readonly _disabledForm: () => void = this.effect(((params$: Observable<void>) => params$.pipe(
    switchMap((): Observable<boolean> => this._reportStore.disabled$),
    withLatestFrom(this._reportStore.state$),
    filter(([_, reportStoreState]: [boolean, ReportStoreState]): boolean => reportStoreState.submitted),
    tap(([disabled]: [boolean, ReportStoreState]): void => {
      if (disabled) {
        this.form.disable();
      } else {
        this.form.enable();
      }
    })
  )));

  private readonly _initFormValues: () => void = this.effect((params$: Observable<void>): Observable<[Partial<AdReportParams>, ReportStoreState]> => params$.pipe(
    switchMap((): Observable<[Partial<AdReportParams>, ReportStoreState]> => this._reportStore.reportParams$.pipe(
      withLatestFrom(this._reportStore.state$),
      filter(([params, reportStoreState]: [Partial<AdReportParams>, ReportStoreState]): boolean => reportStoreState.initialized),
      tap(([params, reportStoreState]: [Partial<AdReportParams>, ReportStoreState]): void => {
        this.form.patchValue(params, { emitEvent: true });
        if (reportStoreState.submitted) {
          this.form.setValidators([FormValidators.reportFormIsValid(this.form.value)]);
          this.form.updateValueAndValidity({ emitEvent: false });
        }
      })
    ))
  ));

  private readonly _loading: () => void = this.effect(() => this._store.select(selectBackgroundLoaded).pipe(
    map((loaded: boolean) => {
      if (loaded) {
        this.form.enable();
      } else {
        this.form.disable();
      }
    })
  ));

  constructor(
    private readonly _reportStore: ReportStore,
    private readonly _store: Store<AppState>
  ) {
    super(null);
  }

  public init(): void {
    this._disabledForm();
    this._initFormValues();
  }

  public submit(): void {
    this._reportStore.updateReportParamsSubmitted(this.form.value);
    this.form.setValidators([FormValidators.reportFormIsValid(this.form.value)]);
    this.form.updateValueAndValidity({ emitEvent: false });
  }

}

